<template>
	<div class="funnel-container">
		<div v-if="showMarquee" class="funnel-container__marquee">
			<PaywallMarquee :content="['FINAL DAY OF MEGA SALE', '⚡', 'FINAL DAY OF MEGA SALE', '⚡']" theme="purple" />
		</div>
		<slot></slot>
	</div>
</template>

<script>
import PaywallMarquee from '@/modules/Paywall/components/PaywallMarquee.vue'

export default {
	name: 'FunnelContainer',
	components: { PaywallMarquee },

	watch: {
		$route: {
			handler(newVal) {
				if (this.IS_FEMALE_SCROLLING_URGENCY_MESSAGING_EXP) {
					this.showMarquee = !!newVal.path.endsWith('f/ob/a-input')
				}

				if (this.IS_WALKING_GS_SCROLLING_URGENCY_MESSAGE_EXP) {
					this.showMarquee = newVal.meta.isLanding && newVal.query.step === '1'
				}
			},

			immediate: true,
		},
	},

	data() {
		return {
			showMarquee: false,
		}
	},
}
</script>

<style lang="scss" scoped>
.funnel-container {
	min-height: 100vh;
	min-height: 100dvh;
}
</style>
